export default {
  mainContainer: 'bg-color-bg w-[100%]',
  container: 'max-w-[1440px] mx-auto px-[5vw]',
  contentWrapper: 'max-w-[1440px] py-[100px]',
};
